import { ReactNode, useCallback, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useRouter } from 'next/router';

import CloseSvg from 'public/icons/close.svg';

import { Button } from '../_Button/Button';

import styles from './_SlideOut.module.css';

type SlideOutProps = {
	slideOutState: boolean;
	setSlideOutState: (arg0: boolean) => void;
	fromLeft?: boolean;
	destroy?: boolean;
	children: ReactNode;
	onExit?: () => void;
};

export default function SlideOut(props: SlideOutProps) {
	const router = useRouter();

	const menu = useRef<HTMLElement>(null);
	const overlay = useRef<HTMLDivElement>(null);

	const transitionDuration = 300;

	const closeMenu = useCallback(() => {
		props.setSlideOutState(false);
	}, [props]);

	useEffect(() => {
		router.events.on('routeChangeComplete', closeMenu);

		return () => {
			router.events.off('routeChangeComplete', closeMenu);
		};
	}, [router.events, closeMenu]);

	return (
		<>
			<CSSTransition
				nodeRef={menu}
				in={props.slideOutState}
				timeout={transitionDuration}
				classNames={{ ...styles }}
				unmountOnExit={!props.destroy}
				onEnter={() => document.querySelector('html')?.classList.add('no-scrolling')}
				onExit={() => {
					document.querySelector('html')?.classList.remove('no-scrolling');
					props.onExit?.();
				}}
			>
				<aside
					ref={menu}
					className={`${styles.menu} ${props.destroy ? 'destroy' : ''} ${props.fromLeft ? styles.fromLeft : styles.fromRight}`}
					tabIndex={0}
				>
					<div className={styles.menuWrapper}>
						<Button title="Close" className={`buttonReset ${styles.closeBtn}`} onClick={() => closeMenu()}>
							<CloseSvg />
						</Button>

						{props.children}
					</div>
				</aside>
			</CSSTransition>

			<CSSTransition nodeRef={overlay} in={props.slideOutState} timeout={transitionDuration} classNames={{ ...styles }} unmountOnExit>
				<div ref={overlay} className={`${styles.overlay} ${props.destroy ? 'destroy' : ''}`} onClick={() => closeMenu()} />
			</CSSTransition>
		</>
	);
}
